export const statusConfig = {
  submitted: {
    message: 'Submitted',
    bg: 'bg-[#FC7038]/10',
    barBg: 'bg-[#FC7038]',
    fill: 'fill-[#FC7038]',
    border: 'border-[#FC7038]',
    text: 'text-[#FC7038]',
    edge: 'from-[#FC7038]/50 to-bionic-green/20',
  },
  pending: {
    message: 'Pending',
    bg: 'bg-white/[0.08]',
    barBg: 'bg-transparent',
    fill: 'fill-transparent',
    border: 'border-white/30',
    text: 'text-bionic-muted',
    edge: 'from-white/30 to-white/10',
  },
  rejected: {
    message: 'Rejected',
    bg: 'bg-error/[0.08]',
    barBg: 'bg-transparent',
    fill: 'fill-bionic-error',
    border: 'border-bionic-error',
    text: 'text-bionic-error',
    edge: 'from-bionic-error/30 to-bionic-error/10',
  },
  'in-progress': {
    message: 'In Progress',
    bg: 'bg-[#0BB4FF]/15',
    barBg: 'bg-[#0BB4FF]',
    fill: 'fill-[#0BB4FF]',
    border: 'border-[#0BB4FF]',
    text: 'text-[#0BB4FF]',
    edge: 'from-[#0BB4FF]/50 to-[#0BB4FF]/20',
  },
  complete: {
    message: 'Complete',
    bg: 'bg-bionic-green/10',
    barBg: 'bg-bionic-green',
    fill: 'fill-bionic-green',
    border: 'border-bionic-green',
    text: 'text-bionic-green',
    edge: 'from-bionic-green/50 to-bionic-green/20',
  },
};
